import api from "./api";

export const getCompanyAll = async () => {
    const response = await api.get(`company/listAll`);
    return response.data;
};

export const getCompanyAllSimple = async () => {
    const response = await api.get(`company/listAllSimple`);
    return response.data;
};

export const getCompanyOne = async(id: string) => {
    const response = await api.get(`company/${id}`);
    return response.data;
};

export const getCompanyAllPagination = async (limit?: number, page?: number, corporateName?: string, user?: string, status?: string, includePlantCounts?: boolean) => {
    const response = await api.get(`company/listAllPagination/?limit=${limit ? limit : ""}&page=${page ? page : ""}${corporateName ? `&corporateName=${corporateName}` : ""}${user ? `&user=${user}` : ""}${status ? `&status=${status}` : ""}${includePlantCounts ? `&includePlantCounts=${includePlantCounts}` : ""}`);
    return response.data;
};

export const putCompanyOne = async (id: string, data: any) => {
    const response = await api.put(`company/${id}`, data);
    return response.data;
};